import { CalendarDays, Heart, Home, MessageCircle, Search } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useApp } from "@/context/AppContext";

export const BottomNav = () => {
  const { pathname, hash } = useLocation();
  const { user } = useAuth();
  const { language } = useApp();
  const labels = language === "en" ? ["Home","Search","Bookings","Favorites","Contact"] : language === "es" ? ["Inicio","Buscar","Reservas","Favoritos","Contacto"] : ["Accueil","Rechercher","Réservations","Favoris","Contact"];
  const accountPath=user?.role==="host"?"/partenaire":user?.role==="advertiser"?"/annonceur":user?.role==="admin"?"/admin":"/espace";
  const items = [["/",Home,labels[0],"mobile-home-link"],["/recherche",Search,labels[1],"mobile-search-link"],[accountPath,CalendarDays,labels[2],"mobile-bookings-link"],[`${accountPath}#favoris`,Heart,labels[3],"mobile-favorites-link"],["/messages",MessageCircle,labels[4],"mobile-contact-link"]];
  if (pathname.startsWith("/partenaire") || pathname.startsWith("/admin")) return null;
  return <nav className="bottom-nav" data-testid="mobile-bottom-navigation">{items.map(([to, Icon, label, testId]) => {
    if (!user && ["/espace", "/messages"].includes(to.split("#")[0])) to = "/login";
    const [path, itemHash] = to.split("#");
    const active = pathname === path && (!itemHash || hash === `#${itemHash}`);
    return <Link to={to} className={active ? "active" : ""} key={testId} data-testid={testId}><Icon/><span>{label}</span></Link>;
  })}</nav>;
};